import React from 'react';

import { List } from 'components/List';
import { Icon } from 'components/tokens/Icon';
import { checkCircleBold } from 'icons/default';
import { Colors } from 'enums/Colors';
import { ListItemProps, ListItemSize } from 'components/List/ListItem';

import styles from './Control.module.scss';

interface IControl {
  items: Array<ListItemProps>;
}

export const Control: React.VFC<IControl> = ({ items }) => (
  <div className={styles.control}>
    <h2 className={styles['title-approved']}>
      <Icon icon={checkCircleBold} color={Colors.MintSweet500} size={29} />
      Digital kontroll
    </h2>
    <div className={styles.info}>
      Vi genomför en digital kontroll så att du som köpare kan känna dig trygg.
    </div>
    <h3 className={styles['title-report']}>Kontrollrapport</h3>
    <div className={styles['list-wrapper']}>
      <List
        bgColor={Colors.Transparent}
        dividerColor={Colors.DarkBlue700}
        listItemLabelColor={Colors.DarkBlue100}
        listItemValueColor={Colors.White}
        items={items}
        size={ListItemSize.Small}
      />
    </div>
    <div className={styles['link-wrapper']} />
  </div>
);
